import gql from 'graphql-tag';

export const UPSERT_LOCATION = gql`
  mutation UpsertLocation($input: UpsertLocationInput!, $file: Upload) {
    upsertLocation(input: $input, file: $file)
  }
`;
